import type { User } from '@si/types';

export function ensureSiAdmin(user?: User | null, errorMessage = 'Admin access required.') {
  if (!user?.isSiAdmin) {
    throw new Error(errorMessage);
  }
}
